import { useAuthStore } from '@/stores/auth'

export default function () {
  const authStore = useAuthStore()
  const res = {
    isPublicUser: authStore.isGuestUser
  }
  return res
}
